import GenericDialog from "../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {Button, Grid, Typography} from "@material-ui/core";
import IconLeft from "@material-ui/icons/ChevronLeft";
import PropTypes from "prop-types";
import {useMemo, useState} from "react";
import ConsegneStep from "./consegne-step/ConsegneStep";
import ConsegnatiStep from "./consegnati-step/ConsegnatiStep";

const DeviceDetails = (props) => {
    const [step, setStep] = useState(0)
    const [selectedOrderId, setSelectedOrderId] = useState("")

    const handleVediDettagli = (orderId) => {
        setSelectedOrderId(orderId)
        setStep(1)
    }

    const dialogTitle = useMemo(() => {
        if (step === 0) {
            return props.data.modello
        }
        return `${props.data.modello} (Ordine ${selectedOrderId})`
    }, [step, props.data.modello, selectedOrderId])

    const handleBackClick = () => {
        if (step === 1) {
            setStep(0)
            return
        }
        props.handleDialogClose();
    }

    const dialogContent = (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Button variant={"text"}
                        color={"primary"}
                        onClick={handleBackClick}
                        startIcon={<IconLeft/>}>
                    Indietro
                </Button>
            </Grid>
            {step === 0 ?
                <ConsegneStep data={props.data} handleVediDettagli={handleVediDettagli}/> :
                <ConsegnatiStep commercialLabel={props.data.commercialLabel} orderId={selectedOrderId}/>}

        </Grid>
    )

    return <GenericDialog open={props.open}
                          handleDialogCloseButton={props.handleDialogClose}
                          handleDialogClose={props.handleDialogClose}
                          dialogWidth={"lg"}
                          dialogContent={dialogContent}>
        <Typography variant={"h5"}>{dialogTitle}</Typography>
    </GenericDialog>
}

DeviceDetails.propTypes = {
    data: PropTypes.shape({
        modello: PropTypes.string,
        qtaContrattualizzata: PropTypes.string,
        qtaConsegnata: PropTypes.string,
        tipoVendita: PropTypes.string,
        contributoAttivazione: PropTypes.string,
        pagamentoMensile: PropTypes.string,
        pagamento: PropTypes.string
    }).isRequired,
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired
}

export default DeviceDetails;
